import { render, staticRenderFns } from "./ItemUnitModal.vue?vue&type=template&id=639ed58d&"
import script from "./ItemUnitModal.vue?vue&type=script&lang=js&"
export * from "./ItemUnitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('639ed58d')) {
      api.createRecord('639ed58d', component.options)
    } else {
      api.reload('639ed58d', component.options)
    }
    module.hot.accept("./ItemUnitModal.vue?vue&type=template&id=639ed58d&", function () {
      api.rerender('639ed58d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/ItemUnitModal.vue"
export default component.exports